import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsDataManagerGettingStartedEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-assets-data-manager-getting-started-page", jiraSpaEntry: "async-assets-data-manager-getting-started-page" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
